export default "__VITE_ASSET__89cc6ff6__"